export default async function createDuplexerConnection({ duplexerUrl, blogApiBaseUrl, instance }) {
  const { Duplexer } = await import(/* webpackChunkName: "wix-duplexer" */ './wix-duplexer');

  const duplexerClient = new Duplexer(duplexerUrl);
  return duplexerClient.connect({
    apiKey: '8dd942aa-6255-4bb0-b004-8bd6cf2f6b35', // HACK
    auth: {
      url: `${blogApiBaseUrl}/_api/duplexer/auth`,
      onBeforeRequest: () => ({
        headers: {
          instance,
        },
      }),
    },
  });
}
